import { useEffect } from 'react';
import { WithScope } from '@mews-commander/types';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useCommanderSelector } from '@mews-commander/utils';
import { getFirstCheckedReservationId } from '../../selectors';
import { useBestWesternIntegrationId } from '../../../bestWestern/hooks';
import { useFetchingContext } from '../ReservationModule/context';
import { GroupExistingCustomer } from './GroupExistingCustomer/GroupExistingCustomer';
import { GroupAddCustomer } from './GroupAddCustomer/GroupAddCustomer';

export const SingleReservationCheckedComponents = ({
    scope,
    onSuccess,
}: WithScope & {
    onSuccess?: () => void;
}) => {
    const enterpriseId = useCurrentEnterpriseId();

    const { integrationId, isLoading: isFetchingIntegrationId } = useBestWesternIntegrationId({ enterpriseId });
    const { setFetching } = useFetchingContext();

    const firstCheckedReservationId = useCommanderSelector((state) => getFirstCheckedReservationId(state, { scope }));

    useEffect(() => {
        setFetching(isFetchingIntegrationId);
    }, [setFetching, isFetchingIntegrationId]);

    const isBestWesternIntegrationEnabled = isFetchingIntegrationId ? false : !!integrationId;

    return (
        <>
            <GroupExistingCustomer
                reservationId={firstCheckedReservationId || ''}
                scope={scope}
                canCreateNewOne={isBestWesternIntegrationEnabled}
                onSuccess={onSuccess}
            />
            {!isBestWesternIntegrationEnabled && firstCheckedReservationId ? (
                <GroupAddCustomer scope={scope} onSuccess={onSuccess} reservationId={firstCheckedReservationId} />
            ) : null}
        </>
    );
};
